//PROD
// export const API_BASE_URL='https://www.clgmerchantreports.bdo.com.ph/clg-ors-api/';
export const API_BASE_URL='/clg-ors-api/';
export const ORS_BASE_URL='';

//SIT
//export const API_BASE_URL='https://www.clgmerchantreports.sit.bdo.com.ph/clg-ors-api/';
//export const API_BASE_URL='https://app01.clgmerchantreports.sit.bdo.com.ph:50443/clg-ors-api/';


//DEV
 //export const API_BASE_URL='http://localhost:8090/clg-ors-api/';
 //export const ORS_BASE_URL='http://localhost:8090';

//UAT
//export const API_BASE_URL='https://www.clgmerchantreports.uat.bdo.com.ph/clg-ors-api/';
export const DEV_REV = '1.0.6 BUILD_DATE:02-05-2026';

export const ACCESS_TOKEN='accessToken';
export const REFRESH_TOKEN='RefreshToken';
export const RESPONSE=null;
export const USERDATA="USER";
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 15;
export const EMAIL_MAX_LENGTH = 40;
export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;
export const VIEW_FILE='';

/*TYPES OF REPORTS*/
export const MERCHANT_REPORT = '1';
export const MERCHANT_SOA = '2';
export const TRANSACTION_DETAILS = '3';
export const FILE_NAME='FILE';
export const CREDIT_NOTICE = '4';
export const CUSTOMER_SERVICE_REPORT = '5';
export const CUSTOMIZED_REPORT = '6';
export const IST_REPORT = '7';
export const JSONFILE = '';

/* Monina added - for PDF files */
//export const PDF_REPORTS_URL = './media/web/viewer.html?file=';
//export const PDF_REPORTS_URL = 'http://bdouclg10.bdo.com.ph:8080/mors/media/';  //for SIT
//export const PDF_REPORTS_URL = 'https://www.clgmerchantreports.uat.bdo.com.ph/mors/media/';  //for UAT
//export const PDF_REPORTS_URL = 'https://www.clgmerchantreports.sit.bdo.com.ph/mors/media/';  //for UAT

export const PDF_REPORTS_URL = '/appdir/apache-tomcat-7.0.56/webapps/CLGMORS/help/'

export const DISABLED_MENU = [ 
    {'menu':'CUSTOMER SERVICE'},
    {'menu':'OTP GENERATOR'},
    {'menu':'ONLINE REPORTS'}
]
export const DISABLED_SUBMENU = {
    "Customer Service Reports":""//,
    //"Change Password":""
}